import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AdditionalServicesApiService } from './additional-services.api.service';
import * as AdditionalServicesActions from './additional-services.actions';
import { catchError, map, mergeMap, withLatestFrom, filter, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectAdditionalServiceLevelRequest } from './additional-services.selectors';

@Injectable()
export class AdditionalServicesEffects {
  constructor(
    private actions$: Actions,
    private api: AdditionalServicesApiService,
    private store: Store,
  ) {}

  loadAdditionalServiceLevel$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdditionalServicesActions.loadAdditionalServiceLevel),
      withLatestFrom(this.store.select(selectAdditionalServiceLevelRequest)),
      filter(([{ request }, currentRequest]) => {
        if (!currentRequest) {
          return true;
        }
        return JSON.stringify(request) !== JSON.stringify(currentRequest);
      }),
      tap(([{ request }, _]) => {
        this.store.dispatch(AdditionalServicesActions.loadAdditionalServiceLevelRequest({ request }));
      }),
      mergeMap(([{ request }]) =>
        this.api.getServicesLevel(request.plantId, request.contractCode).pipe(
          map((response) => AdditionalServicesActions.loadAdditionalServiceLevelSuccess({ response })),
          catchError((error) => of(AdditionalServicesActions.loadAdditionalServiceLevelFailure({ error }))),
        ),
      ),
    ),
  );

  retryAdditionalServiceLevel$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdditionalServicesActions.retryAdditionalServiceLevel),
      withLatestFrom(this.store.select(selectAdditionalServiceLevelRequest)),
      filter(([_, request]) => {
        return !!request;
      }),
      mergeMap(([_, request]) =>
        this.api.getServicesLevel(request.plantId, request.contractCode).pipe(
          map((response) => AdditionalServicesActions.loadAdditionalServiceLevelSuccess({ response })),
          catchError((error) => of(AdditionalServicesActions.loadAdditionalServiceLevelFailure({ error }))),
        ),
      ),
    ),
  );
}
